'use client';

import {
  HowYourPlanWorks,
  HowYourPlanWorksCardType,
  GlobalStylesVisid,
} from '@monetization/hpaip-components-library';
import { useTranslation } from 'react-i18next';
import { NamespacesI18n } from '@storefront/i18n';
import { buildPath } from '@storefront/utils/utils';
import DataCollection from '@storefront/services/DataCollection';
import { uiEvents } from '@storefront/services/DataCollection/simpleUiEvents';

export const HowYourPlanWorksV2 = () => {
  const { t } = useTranslation(NamespacesI18n.PDP_CONFIG, {
    keyPrefix: 'howYourPlanWorksV2',
  });
  const planInformations = t('cards', {
    returnObjects: true,
  }) as HowYourPlanWorksCardType[];

  const cards = planInformations.map((plan) => ({
    ...plan,
    image: {
      ...plan.image,
      src: buildPath(plan.image.src),
    },
  }));

  const customPadding = {
    desktopLarge: `80px ${GlobalStylesVisid.paddingDesktopLarge} 20px ${GlobalStylesVisid.paddingDesktopLarge}`,
    desktopRegular: `80px ${GlobalStylesVisid.paddingDesktopRegular} 20px ${GlobalStylesVisid.paddingDesktopRegular}`,
    desktopSmall: `80px 48px 20px 48px`,
    desktopXS: `80px 0 20px 0`,
    tablet: `48px 0 12px 0`,
    mobile: `40px 0 8px 0`,
  };

  const handleActionClick = (
    actionName: string,
    event?: React.MouseEvent<HTMLAnchorElement>
  ) => {
    const url = event?.currentTarget?.href || actionName;
    DataCollection.sendEvent(uiEvents.printerHowItWorksBC, {
      screenName: 'PrinterConfigurationPage',
      controlDetail: url,
    });
  };

  return (
    <div>
      <HowYourPlanWorks
        title={t('title')}
        cards={cards}
        customPadding={customPadding}
        onActionClick={handleActionClick}
      />
    </div>
  );
};
